import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCategoryArticles } from '../actions/fetchCategoryArticles';
import { getSelectedCategory, getRequestStatusSelectedCategoryArticles } from '../selectors/kbLibrarySelectors';
import ArticleOrCategoryList from './ArticlesList';
import styled from 'styled-components';
import LoadingState from '../../components/LoadingState';
import { getSearchableKnowledgeBaseIds } from '../../widget-data/selectors/widgetDataSelectors';
import { PENDING } from 'conversations-internal-schema/constants/RequestStatusTypes';
import { Section } from './Section';
import { jsx as _jsx } from "react/jsx-runtime";
const CategoryArticlesWrapper = styled.div.withConfig({
  displayName: "CategoryArticles__CategoryArticlesWrapper",
  componentId: "sc-1wn3409-0"
})(["height:100%;overflow-y:scroll;"]);
export default function CategoryArticles() {
  const dispatch = useDispatch();
  const selectedCategory = useSelector(getSelectedCategory);
  const [knowledgeBaseId] = useSelector(getSearchableKnowledgeBaseIds);
  const {
    id: categoryId
  } = selectedCategory;
  const requestStatusSelectedCategoryArticles = useSelector(getRequestStatusSelectedCategoryArticles);
  useEffect(() => {
    void dispatch(fetchCategoryArticles({
      knowledgeBaseId,
      categoryId
    }));
  }, [dispatch, categoryId, knowledgeBaseId]);
  if (requestStatusSelectedCategoryArticles === PENDING) {
    return /*#__PURE__*/_jsx(LoadingState, {});
  }
  return /*#__PURE__*/_jsx(CategoryArticlesWrapper, {
    children: /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(ArticleOrCategoryList, {
        hideSubtitle: true,
        items: selectedCategory.articles
      })
    })
  });
}
CategoryArticles.displayName = 'CategoryArticles';